<py-full-pallet-upgrade
  *ngIf="(fullPalletUpgrade?.upgradable || isAlreadyUpdated) && !isSkipped"
  [isAlreadyUpdated]="isAlreadyUpdated"
  [fullPalletUpgrade]="fullPalletUpgrade"
  (update)="onPalletUpgrade()"
  (skipUpdate)="onPalletUpgradeSkip()"
></py-full-pallet-upgrade>
